import { useIsDesktopDevice } from "../../tools/hooks/useIsDesktopDevice.ts";
import UserManagementDesktopView from "./desktop/UserManagement.desktop.view.tsx";

export default function UserManagementView() {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <UserManagementDesktopView />}</>;
}
